import { Injectable, signal } from '@angular/core';

export type ToastVariant = 'info' | 'error' | 'success';

export interface ToastItem {
  id: number;
  message: string;
  variant: ToastVariant;
}

const DEFAULT_DURATION_MS = 4000;

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<ToastItem[]>([]);
  readonly toasts = this._toasts.asReadonly();
  private seq = 0;

  show(message: string, variant: ToastVariant = 'info', durationMs = DEFAULT_DURATION_MS): number {
    const id = ++this.seq;
    this._toasts.update(list => [...list, { id, message, variant }]);
    if (durationMs > 0) {
      setTimeout(() => this.dismiss(id), durationMs);
    }
    return id;
  }

  error(message: string, durationMs = DEFAULT_DURATION_MS): number {
    return this.show(message, 'error', durationMs);
  }

  info(message: string, durationMs = DEFAULT_DURATION_MS): number {
    return this.show(message, 'info', durationMs);
  }

  success(message: string, durationMs = DEFAULT_DURATION_MS): number {
    return this.show(message, 'success', durationMs);
  }

  dismiss(id: number): void {
    this._toasts.update(list => list.filter(t => t.id !== id));
  }
}
